import Vue from 'vue'
import Checkout from './checkout/checkout'
import ImportantDays from './important-days/important-days'
import SurveyApp from './survey/survey-app.vue'

function initVueCheckout() {
  const checkoutEl = document.querySelector('.vue-checkout')

  if (!checkoutEl) {
    return
  }

  new Vue({
    el: checkoutEl,
    components: {
      Checkout
    },
    provide: {
      checkoutLanguage: window.localisation.get('checkout')
    },
  })
}

function initVueImportantDays() {
  const importantDaysEl = document.querySelector('.vue-important-days')

  if(!importantDaysEl) {
    return
  }

  const {
    textTitle: title,
    textYourData: data,
    textEnterDates: dates,
    textDate: date,
    textPhone: phone,
    textName: name,
    textEmail: email,
    textEventName: eventName,
    textSelectDate: selectDate,
    textMore: more,
    textSave: save,
    textError: error
  } = importantDaysEl.dataset
  const text = {
    title,
    data,
    dates,
    date,
    phone,
    name,
    email,
    eventName,
    selectDate,
    more,
    save,
    error
  }

  new Vue({
    el: importantDaysEl,
    render(h) {
      return h(ImportantDays, {
        props: {
          text
        }
      })
    }
  })
}

function initVueSurvey() {
  const surveyElement = document.querySelector('.vue-survey')
  if (!surveyElement) {
    return
  }

  const {name, questions, surveyId, localisation, finishLink, anonym} = surveyElement.dataset
  new Vue({
    el: surveyElement,
    render(h) {
      return h(SurveyApp, {
        props: {
          name,
          questions: questions ? JSON.parse(questions) : [],
          surveyId,
          localisation: localisation ? JSON.parse(localisation) : null,
          finishLink,
          anonym: anonym === 'true'
        }
      })
    }
  })
}

export function initVue() {
  initVueCheckout()
  initVueImportantDays()
  initVueSurvey()
}
